import axios from "axios";
import stage from "../utils/stage";

const api = axios.create({
  baseURL: `https://api.datasales.info/midia-indoor-${stage}/`,
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export default api;
